import React from "react";
import styled from "@emotion/styled";
import FooterMainInfo from "./FooterMainInfo/FooterMainInfo";
import FooterLinks from "./FooterLinks/FooterLinks";
import Subfooter from "./Subfooter/Subfooter";

const ContainerFooter = styled.footer`
  background: url("https://res.cloudinary.com/djiqf3usa/image/upload/v1770090701/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-academy-dark-gold-footer-background_xh9jry.webp");
  background-position: bottom;
  background-size: cover;
  background-repeat: no-repeat;

  .f-container {
    display: flex;
    justify-content: space-between;
    padding: 7rem 0 2rem;
    flex-wrap: wrap;
    flex-direction: column-reverse;
  }

  .container-btn {
    justify-content: center;
  }

  .footer-links {
    display: flex;
    justify-content: center;
    margin-bottom: 4rem;

    .nav {
      flex: 0 0 40%;
      max-width: 40%;
    }

    .t-h-4 {
      margin-bottom: 1.5rem;
      text-align: center;
    }

    .nav-link {
      color: #fff;
      padding: 0.4rem 0;
      font-size: 1.4rem;
      text-align: center;

      :hover {
        color: #f5e7d3;
        transition: all 0.3s ease;
      }
    }

    .is-active {
      color: var(--brand-1);
    }
  }

  .subfooter {
    background: rgb(0 0 0 / 50%);
    padding: 3rem 0;

    .copyright {
      font-size: 1.3rem;
      font-weight: 700;
      text-align: center;
      margin-bottom: 3rem;
      flex: 0 0 100%;
      max-width: 100%;

      .enlace {
        display: inline-block;
        color: var(--brand-1);
      }
    }

    .social-media {
      justify-content: center;
      flex: 0 0 17rem;
      max-width: 17rem;
      margin: 0 auto;
    }

    .social-media a {
      font-size: 2rem;
      display: inline;
      border-radius: 1rem;
      border: 0.1rem solid;
      padding: 1.2rem 1.4rem;
      color: rgb(136, 106, 45);
      border-color: rgba(136, 106, 45, 0.5);
    }
  }

  @media only screen and (min-width: 992px) {
    .f-container {
      flex-direction: row;
    }

    .main-info {
      flex: 0 0 70%;
      max-width: 70%;
    }

    .container-btn {
      justify-content: flex-start;
    }

    .footer-links {
      justify-content: space-between;
      flex: 0 0 30%;
      max-width: 30%;

      .nav {
        flex: 0 0 50%;
        max-width: 50%;
      }

      .t-h-4 {
        text-align: left;
      }

      .nav-link {
        text-align: left;
      }
    }

    .subfooter {
      .copyright {
        flex: 0 0 60%;
        max-width: 60%;
        text-align: left;
        margin-bottom: 0;
      }

      .social-media {
        margin: 0;
      }
    }
  }
`;

const G02MainFooter = () => {
  return (
    <ContainerFooter>
      <div className="t-container f-container">
        <FooterMainInfo />
        <FooterLinks />
      </div>

      <Subfooter />
    </ContainerFooter>
  );
};

export default G02MainFooter;
